// Configuración de Firebase para Horia
// Este archivo conecta la app con tu proyecto de Firebase (base de datos + login)

import { initializeApp, getApps } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { getMessaging, isSupported } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyA5VThFIS9O-RqxmoyxAsWfWhrfqr5PFpo",
  authDomain: "hito-640bd.firebaseapp.com",
  projectId: "hito-640bd",
  storageBucket: "hito-640bd.firebasestorage.app",
  messagingSenderId: "720423427986",
  appId: "1:720423427986:web:0479793f641d5eb4edeb4b"
};

// Inicializa Firebase
const app = initializeApp(firebaseConfig);

// App Check: protege la base de datos contra robots y peticiones que no vengan
// de verdad desde esta app (usando reCAPTCHA v3, invisible para las personas).
initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider("6LdXqkQtAAAAAINVpp8dflttiz5PZdWaFH7K91uV"),
  isTokenAutoRefreshEnabled: true,
});

// Segunda instancia de Firebase, independiente de la principal.
// Se usa SOLO para crear el PIN/cuenta de un empleado nuevo sin que eso
// cierre la sesión del Encargado que está creándolo.
const secondaryApp = initializeApp(firebaseConfig, 'secondary');

// Exporta la base de datos (Firestore) y el sistema de login (Auth)
// para que el resto de la app pueda usarlos
export const db = getFirestore(app);
export const auth = getAuth(app);
export const secondaryAuth = getAuth(secondaryApp);

// Notificaciones push (Firebase Cloud Messaging). No todos los navegadores las
// soportan (por ejemplo Safari en iOS antes de convertir la app en PWA instalada,
// o navegadores muy antiguos), así que en vez de asumir que siempre funciona,
// comprobamos primero con isSupported() y exportamos una promesa: cuando se
// resuelva, o trae la instancia de messaging lista para usar, o trae null si este
// dispositivo/navegador no puede recibir notificaciones — el código que la use
// (en App.jsx) simplemente no hace nada si le llega null, sin romper la app.
export const messagingPromise = (async () => {
  try {
    const soportado = await isSupported();
    return soportado ? getMessaging(app) : null;
  } catch (_) {
    return null;
  }
})();